<template>
  <div class="h-100">
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header display-inline">
      <div class="d-flex align-items-center form-ui-title display-inline">
        <img
          class="back-to-list-apps"
          style="vertical-align: top;"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/ai')"
        >
        <div
          class="d-flex flex-column m__l--10 display-inline"
          style="max-width: 285px;">
          <h3 class="label-header-form-ui ellipsis m--0">
            {{ detailAi ? detailAi.name : '' }}
          </h3>
          <span style="font-size: 12px">
            {{ detailAi ? detailAi.id : '' }}
          </span>
        </div>
      </div>
      <div
        class="d-flex align-items-center justify-content-between display-inline info-action"
        style="border-left: 1px solid #E7E7E7; vertical-align: top;">
        <div class="display-inline">
          <div
            class="d-flex align-items-center"
            style="flex-flow: nowrap">
            <img
              :src="require('../../assets/icon/storage.png')"
              height="24"
              class="m__l--20">
            <div
              v-if="detailAi"
              class="d-flex flex-column m__l--20"
              style="font-size: 12px; line-height: 1">
              <span
                class="label-header-form-ui font-weight-bold"
                style="font-size: 12px">
                {{ detailFormData ? detailFormData.name : '&nbsp;' }}
              </span>
              <span style="font-size: 12px">
                data_set
              </span>
            </div>
          </div>
        </div>

        <div class="btn-action-experience display-inline pull-right">
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10 m__l--20"/>
          <button
            class="btn pull-right m__l--10"
            style="background: #E3F1FE; color: #1A85E4"
            @click="updateAi">
            <i
              class="fa fa-check"
              style="font-size: 20px"
            />
            Update
          </button>
          <button
            class="btn btn-secondary btn-train pull-right"
            @click="$refs.aiTrainModal.show()">
            <img
              :src="require('@/assets/form-ui/train.png')">
            Train
          </button>
        </div>
      </div>
    </div>

    <div class="experience-page-content display-inline h-100">
      <div
        id="list-form-ui"
        class="list-forms display-inline">
        <div class="component-body">
          <h4>General</h4>
          <div
            v-for="item in sectionGeneral"
            :key="item.id"
            :class="{ 'active': menu_active === item.name }"
            class="col-12 d-flex justify-content-between
            component-card-form cursor-pointer align-items-end"
            @click="setActiveMenu(item.name)">
            <div class="d-flex align-items-center">
              <img
                :src="require(`@/assets/form-ui/${item.icon}.png`)"
                width="24"
                height="24"
                class="m__r--16">
              <h4 class="title-form-component">{{ item.name }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="form-ui-container display-inline">
        <j-ai-content
          v-if="showComponent"
          ref="menuContent"
          :ai-detail="detailAi"
          :form-data="detailFormData"
          :menu="generateParam"
        />
      </div>
    </div>

    <b-modal
      ref="appCodeAiModal"
      class="mod-form modal-code-form-data"
      centered>
      <div class="label-create-form-data">VIEW CODE</div>
      <span
        class="btn-copy"
        @click="copyCode">
        <i class="fa fa-files-o font-weight-bold cursor-pointer"/> Copy
      </span><br>
      <div class="scroll-script">
        <prism-editor
          v-model="jsonData"
          :highlight="highlighter"
          :line-numbers="true"
          :class="{'dark-mode' : darkMode}"
          class="my-editor m__t--10"
        />
      </div>
      <br>
      <b-row>
        <b-col md="6">
          <div style="opacity: 0;">
            <textarea
              id="view-code"
              ref="viewCode"
              :value="viewCode"/>
          </div>
        </b-col>
        <b-col md="6">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCodeForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="aiTrainModal"
      class="mod-form modal-add-ai"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">ARE YOU SURE TO TRAIN ?</div>
      <b-form-group :class="{'error-input' : $v.model_name.$error}">
        <label> Model Name * </label>
        <j-input
          v-model="$v.model_name.$model"
          :error-required="$v.model_name.$error"
          :max-length="255"
          palceholder="Model Name" />
      </b-form-group>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeTrain">
              No
            </b-button>
            <b-button
              class="btn blue"
              @click="actionTrainAi">
              Yes
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-popover
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      container="studio-page-header"
      placement="left">
      <div
        class="form-ui-opt"
        @click="openCodeForm">
        View Code
      </div>
      <div
        class="form-ui-opt"
        @click="deleteDataAi">
        Delete
      </div>
    </b-popover>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { highlight, languages } from 'prismjs/components/prism-core';
import { required } from 'vuelidate/lib/validators';

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

import jAiContent from '@/views/ai/jAiContent';

export default {
  components: {
    jAiContent,
    PrismEditor,
  },
  data() {
    return {
      detailAi: null,
      detailFormData: null,
      menu_active: 'Information',
      sectionGeneral: [
        {
          name: 'Information',
          section: 'general',
          icon: 'info',
        },
        {
          name: 'Model',
          section: 'general',
          icon: 'model',
        },
      ],
      jsonData: '',
      viewCode: '',
      darkMode: false,
      configPopoverShow: false,
      variablePopoverShow: false,
      showComponent: false,
      model_name: null,
    };
  },
  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail', 'changed_tab', 'changes_value_view']),
    ...mapState('jStoreAi', ['ai_updated']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    generateParam() {
      return this.menu_active.toLowerCase().replace(' ', '-');
    },
  },
  watch: {
    form_data_detail(val) {
      this.detailFormData = val[0];
      this.showComponent = true;
    },

    changed_tab() {
      this.menu_active = 'Information';
    },

    ai_updated() {
      this.getDataDetailAi();
    },
  },
  created() {
    this.getDataDetailAi();
  },
  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailFormData']),
    ...mapActions('jStoreAi', ['getDetailAi', 'deleteAi', 'trainAi']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    getDataDetailAi() {
      const param = {
        id: this.$route.params.id,
      };
      this.getDetailAi(param).then((res) => {
        this.detailAi = res.data.data;
        if (this.detailAi.data_manager_id) {
          const dataFilterForm = {
            id: [this.detailAi.data_manager_id],
          };
          const paramForm = {
            limit: 0,
            page: 1,
            filter: JSON.stringify(dataFilterForm),
          };
          this.actionGetDetailFormData(paramForm);
        }
      });
    },

    setActiveMenu(name) {
      if (this.changes_value_view) {
        const text = 'Are you sure want to move without save your changes ?';
        this.$swal({
          title: 'Warning',
          text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            this.menu_active = name;
            this.setChangesValueView(false);
          }
        });
      } else {
        this.menu_active = name;
      }
    },

    highlighter(code) {
      return highlight(code, languages.js); // returns html
    },

    openCodeForm() {
      this.configPopoverShow = false;
      const id = this.detailAi.id;
      const companyId = this.detailAi.company_id;
      const createdBy = this.detailAi.created_by;
      const updatedBy = this.detailAi.updated_by;
      const createdAt = this.detailAi.created_at;
      const updatedAt = this.detailAi.updated_at;
      const code = this.detailAi;

      delete code.id;
      delete code.created_by;
      delete code.updated_by;
      delete code.created_at;
      delete code.updated_at;
      delete code.company_id;

      this.jsonData = JSON.stringify(code, null, 4);
      this.viewCode = JSON.stringify(code, null, 4);
      this.$refs.appCodeAiModal.show();

      this.detailAi.id = id;
      this.detailAi.company_id = companyId;
      this.detailAi.created_by = createdBy;
      this.detailAi.updated_by = updatedBy;
      this.detailAi.created_at = createdAt;
      this.detailAi.updated_at = updatedAt;
    },

    copyCode() {
      const codeToCopy = this.$refs.viewCode;
      codeToCopy.setAttribute('type', 'text');
      codeToCopy.select();
      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // eslint-disable-next-line
        alert('Code was copied ' + msg);
      } catch (err) {
        // eslint-disable-next-line
        alert('Oops, unable to copy');
      }
      /* unselect the range */
      window.getSelection().removeAllRanges();
    },

    closeCodeForm() {
      this.jsonData = '';
      this.$refs.appCodeAiModal.hide();
    },

    deleteDataAi() {
      this.configPopoverShow = false;
      const text = `Are you sure to delete ${this.detailAi.name}?`;

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = {
            id: this.detailAi.id,
          };
          const res = await this.deleteAi(params);
          if (!res.error) {
            this.$router.push('/ai');
          }
        }
      });
    },

    updateAi() {
      if (this.showComponent) {
        this.$refs.menuContent.save();
      }
    },

    closeTrain() {
      this.model_name = null;
      this.$refs.aiTrainModal.hide();
    },

    actionTrainAi() {
      this.$v.model_name.$touch();
      if (!this.$v.model_name.$error) {
        const param = {
          ai_id: this.detailAi.id,
          model_name: this.model_name,
        };
        this.trainAi(param).then((response) => {
          if (!response.data.error) {
            this.closeTrain();
          }
        });
      }
    },
  },
  validations() {
    return {
      model_name: { required },
    };
  },
};
</script>

<style lang="scss" scoped>
  .btn-train {
    border-radius: 7px;
    background-color: #DFFFEF;
    color: #218B82;
    border: 0;
    padding: 7px 19px;
    font-size: 14px !important;
    height: 38px;
    width: 100px;

    // &:hover {
    //   background-color: #E1E1E1;
    // }

    // &:active {
    //   background-color: #F2F2F2 !important;
    //   color: black !important;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/views/ai/jAiDetail.vue